module.exports = __webpack_public_path__ + "static/media/Inter-Light.0213ae9d.ttf";